import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M568.129648 0.0124561278L392 176.142104 1175.86412 960.130789 392 1743.87035 568.129648 1920 1528.24798 960.130789z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "matrix(-1 0 0 1 1920.135 0)"
});

var IconArrowOpenLeftSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconArrowOpenLeftSolid, _Component);

  var _super = _createSuper(IconArrowOpenLeftSolid);

  function IconArrowOpenLeftSolid() {
    _classCallCheck(this, IconArrowOpenLeftSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconArrowOpenLeftSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconArrowOpenLeftSolid /> is deprecated. Please use <IconArrowOpenStartSolid /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconArrowOpenLeft",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconArrowOpenLeftSolid.displayName = "IconArrowOpenLeftSolid";
  return IconArrowOpenLeftSolid;
}(Component);

IconArrowOpenLeftSolid.glyphName = 'arrow-open-left';
IconArrowOpenLeftSolid.variant = 'Solid';
IconArrowOpenLeftSolid.deprecated = true;
IconArrowOpenLeftSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconArrowOpenLeftSolid;
export { IconArrowOpenLeftSolid };